"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-a3c23a86"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = { class: "famous-view" };
var vue_3 = require("vue");
var vue_router_1 = require("vue-router");
var ancient_poetry_1 = require("@/apis/ancient-poetry");
exports.default = (0, vue_1.defineComponent)({
    __name: 'FamousView',
    setup: function (__props) {
        /* eslint-disable */
        var router = (0, vue_router_1.useRouter)();
        var list = (0, vue_3.ref)([]);
        var fetchTableData = function () {
            ancient_poetry_1.ancientPoetryApi.getFamousList().then(function (res) {
                list.value = res.data;
            });
        };
        fetchTableData();
        var linkFmous = function (value) {
            router.push({ path: "/ancient/famous/detail", query: { id: value.id, title: value.famous_name } });
        };
        return function (_ctx, _cache) {
            var _component_el_link = (0, vue_2.resolveComponent)("el-link");
            var _component_el_tab_pane = (0, vue_2.resolveComponent)("el-tab-pane");
            var _component_el_tabs = (0, vue_2.resolveComponent)("el-tabs");
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createVNode)(_component_el_tabs, { type: "border-card" }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (0, vue_2.createVNode)(_component_el_tab_pane, { label: "名句集合" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(list), function (item, index) {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                        class: "link-famous",
                                        key: item.id
                                    }, [
                                        (0, vue_2.createVNode)(_component_el_link, {
                                            type: "primary",
                                            onClick: function ($event) { return (linkFmous(item)); }
                                        }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(item.famous_name), 1)
                                            ]; }),
                                            _: 2
                                        }, 1032, ["onClick"])
                                    ]));
                                }), 128))
                            ]; }),
                            _: 1
                        })
                    ]; }),
                    _: 1
                })
            ]));
        };
    }
});
